export class VacationType {
  id: number;
  name: string;
  isVacation: boolean;
  /** Vacation types only: employees get a yearly credit for this type. */
  hasCredit?: boolean;
  /** Days (half days allowed) of an employee without a credit of their own for the year. */
  defaultCredit?: number;
  /** With credit: a request larger than the available credit is refused. */
  isRestricted?: boolean;
  /** Received the previous single vacation credit. */
  isCarriedOver?: boolean;
}
